<template>
  <a-modal
    v-model="visible"
    :destroyOnClose="true"
    :footer="null"
    :centered="true"
    @cancel="$emit('cancel')"
    :closable="false"
    width="430px"
  >
    <div slot="title" class="title">
      <img src="/img/icons/warning.svg" :alt="$t('warning.icon')" class="icon" />
      <h3>{{ $t('delete.targeting.info') }}</h3>
    </div>
    <p>{{ $t('delete.targeting.info.p1') }}</p>
    <p class="p2">{{ $t('delete.targeting.info.p2') }}</p>
    <div class="container">
      <a-button @click="$emit('cancel')" class="cancel">{{ $t('cancel') }}</a-button>
      <a-button @click="handleClick" :loading="loading" class="delete">{{
        $t('delete.targeting.info.confirm')
      }}</a-button>
    </div>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { DELETE_ALL_TARGETING_INFO } from '@/store/targetingInfo/actionTypes';

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      deleteAllTargetingInfo: DELETE_ALL_TARGETING_INFO,
    }),
    async handleClick() {
      this.loading = true;

      try {
        await this.deleteAllTargetingInfo();
      } finally {
        this.loading = false;
      }

      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/breakpoints';

.container {
  display: flex;
  justify-content: space-between;
}
h3 {
  display: flex;
  align-items: center;
  font-size: $font-size-headline-small;
}
.cancel,
.delete {
  border: none;
  font-size: $font-size-small;
  font-weight: bold;
}
.cancel {
  background: $background-red;
  color: $red;
  width: 85px;
}
.delete {
  background: $red;
  color: $white;
}
p {
  text-align: center;
  padding-bottom: 10px;
  font-size: $font-size-large;
  color: $dark-grey;
}
.p2 {
  color: $grey;
}
.title {
  display: flex;
}
.icon {
  margin-right: 7px;
}

@media (max-width: $login-base-breakpoint) {
  .container {
    display: flex;
    flex-direction: column-reverse;

    * {
      margin: 10px 0;
    }
  }

  .cancel {
    width: 100%;
  }
}
</style>
